var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pie-item"},[_c('div',{staticClass:"pie-item-holder"}),_c('loading',{attrs:{"items":[50, 50, 50, 50, 50, 50],"margin":5}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }